import styled from 'styled-components';

export const HeroP2 = styled.p`
  margin-top: 20px;
  color: #17fed0;
  font-size: 20px;
  text-align: center;
  font-family: 'Joystix Monospace';
  max-width: 600px;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

export const Input = styled.input`
  font-size: 22px;
  font-family: 'Cursed Timer';
  outline: none;
  border-color: red;
  background: #05c865;
  border: solid 3px #05c865;
  width: 60px;
  border: none;
  text-align: center;
  height: 38px;
  color: black;
    
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
    height: 18px;
  }
`

export const HeroBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DecrementButton = styled.button`
  border-radius: 50px 0 0 50px;
  background: transparent;
  white-space: nowrap;
  padding: 4px 20px;
  color: #05c865;
  font-size: 20px;
  font-family: 'Joystix Monospace';
  outline: none;
  border: solid 3px #05c865;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #000;
    color: #F401f9;
    border: solid 3px #F401f9;
  }

  &:active {
    background: #fff;
    color: #000;
    border: solid 3px #000;
  }
`;

export const IncrementButton = styled.button`
background: transparent;
white-space: nowrap;
padding: 4px 20px;
color: #05c865;
font-size: 20px;
font-family: 'Joystix Monospace';
outline: none;
border: solid 3px #05c865;
cursor: pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover {
  transition: all 0.2s ease-in-out;
  background: #000;
  color: #F401f9;
  border: solid 3px #F401f9;
}

&:active {
  background: #fff;
  color: #000;
  border: solid 3px #000;
}
`;

export const MintButton = styled.button`
border-radius: 0 50px 50px 0;
  background: transparent;
  white-space: nowrap;
  padding: 4px 40px;
  color: #05c865;
  font-size: 20px;
  font-family: 'Joystix Monospace';
  outline: none;
  border: solid 3px #05c865;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #000;
    color: #F401f9;
    border: solid 3px #F401f9;
  }

  &:active {
    background: #fff;
    color: #000;
    border: solid 3px #000;
  }
`;